<template>
  <gkModal class="video-modal" v-model="isShow" @destroy="close" color="videoModal" transition="gk-fade-up" loading>
    <video v-if="data.video" :src="data.video" controls="controls" :autoplay="true"></video>
    <div v-else class="content">
      <!-- 相同的功能，不同的文案分为两个组件 -->
      <!-- 赛道说明模块 -->
      <ModalNote :data="data" v-if="data.isShowBtn" />

      <!-- 区块链赛道模块 -->
      <ModalBlock :data="data" v-else />

    </div>
    <div slot="footer"></div>
  </gkModal>
</template>

<script>
import ModalNote from './components/ModalNote.vue'
import ModalBlock from './components/ModalBlock.vue'

import gkModal from 'gkuiV2/modal'

export default {
  name: 'Modal',
  data: () => ({
    isShow: false
  }),

  components: {
    gkModal,
    ModalNote,
    ModalBlock
  },

  props: {
    data: {
      type: Object,
      default: () => {
        return { video: ''}
      }
    },
    isShowBtn: {
      type: Boolean,
      default: true
    }
  },

  methods: {
    close () {
      this.$emit('close', this)
    }
  },

  created () {
    setTimeout(() => { this.isShow = true })
  }
}
</script>

<style lang="scss" scoped>

.video-modal::v-deep [gk-modal-mask] {
   background: rgba(0,0,0,.8);
}

video {
  width: 100%; height: 100%;
}

.content {
  position: relative;
  padding: 30px;
  background: #FFFFFF;

  @include mobile {
    padding: 30px 20px;
  }
}

</style>
